import { Button, Modal } from "react-bootstrap";

const ViewModal = ({ handleClose, body, view, title }) => {
    return (
        <>
            <Modal show={view} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {body}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="btn btn-primary btn-add" onClick={() => { handleClose(false) }}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ViewModal;